import { configureStore } from '@reduxjs/toolkit';
import { usersSlice } from '@/store/slices/usersSlice';
import { notificationSlice } from '@/store/slices/notificationsSlice';
import { accountSlice } from '@/store/slices/accountSlice';
import { eventsSlice } from '@/store/slices/eventsSlice';
import { sendListSlice } from '@/store/slices/sendListSlice';
import { userEventsSlice } from '@/store/slices/userEventsSlice';

export const store = configureStore({
    reducer: {
        user: usersSlice.reducer,
        notifications: notificationSlice.reducer,
        account: accountSlice.reducer,
        events: eventsSlice.reducer,
        sendList: sendListSlice.reducer,
        userEvents: userEventsSlice.reducer,
    },
});
